import {useState} from 'react';
import {useViewportEffect} from 'react-viewport-utils';

export const useImageParallax = ({
  disabled,
  imageRef,
  wrapperRef,
}: {
  disabled?: boolean;
  imageRef: React.RefObject<HTMLElement | null>;
  wrapperRef: React.RefObject<HTMLElement | null>;
}) => {
  const [isCloseToViewPort, setCloseToViewPort] = useState(false);

  const recalculateLayoutBeforeUpdate = () => {
    if (imageRef.current && wrapperRef.current && !disabled) {
      const {
        top,
        bottom,
        height: wrapperHeight,
      } = wrapperRef.current.getBoundingClientRect();
      const {height: imageHeight} = imageRef.current.getBoundingClientRect();

      return {
        top,
        bottom,
        wrapperHeight,
        imageHeight,
      };
    }
    return null;
  };
  const updateConf = {
    deferUpdateUntilIdle: false,
    priority: isCloseToViewPort ? 'highest' : 'low',
    recalculateLayoutBeforeUpdate,
    disableScrollUpdates: disabled,
    disableDimensionUpdates: disabled,
  } as const;

  useViewportEffect(({dimensions: {height: viewportHeight}}, sizeData) => {
    if (sizeData && imageRef.current) {
      const {top, bottom, wrapperHeight, imageHeight} = sizeData;

      const topProgress = (viewportHeight - top) / viewportHeight;
      const bottomProgress = (viewportHeight - bottom) / viewportHeight;

      const getsCloseToViewport = topProgress > -0.5 && bottomProgress < 1.5;

      if (getsCloseToViewport !== isCloseToViewPort) {
        setCloseToViewPort(getsCloseToViewport);
      }
      const parallaxSpace = Math.round((imageHeight - wrapperHeight) / 2);

      const yShift = Math.round(topProgress * parallaxSpace);

      if (getsCloseToViewport) {
        imageRef.current.style.transform = `translate3D(0,${yShift}px,0)`;
      }
    }
  }, updateConf);

  return {imageRef, wrapperRef};
};
